import ContentWrapper from "./ContentWrapper.jsx";
import React from "react";

class Page404 extends React.PureComponent {
    render(){
        return (
            <ContentWrapper >
                <div>
                    Side ikke funnet 404
                </div>
            </ContentWrapper>
        );
    }
}

export default Page404;